import { render, staticRenderFns } from "./Contact-Person.vue?vue&type=template&id=210e318c"
import script from "./Contact-Person.vue?vue&type=script&lang=js"
export * from "./Contact-Person.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports